// DS: DS4.3
import React from 'react';
import c from 'classnames';
import PlainButtonOrLink from '../../../Buttons/PlainButtonOrLink';
import s from './MainToggle.scss';
/**
 * A switch/toggle.
 *
 * `aria-label` or `aria-labelledby` is required since this component doesn't have a text label in the specification. If you
 * see a type error mention one of these, please add one depending on context.
 */ const MainToggle = ({ id , name , value , size , hasError , disabled , biData , className , innerRef , onChange , 'aria-label': ariaLabel , 'aria-labelledby': ariaLabelledBy , type: buttonType , tabIndex  })=>{
    const isDisabled = disabled || hasError;
    return /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        id: id,
        name: name,
        className: c(className, s['root'], value ? s['on'] : s['off'], isDisabled && s['disabled'], hasError && s['error'], s[size]),
        innerRef: innerRef,
        onClick: ()=>onChange(!value),
        biData: biData,
        disabled: isDisabled,
        "aria-pressed": value,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        type: buttonType,
        tabIndex: tabIndex
    }, /*#__PURE__*/ React.createElement("span", {
        className: s['dot']
    }, hasError && /*#__PURE__*/ React.createElement("span", {
        className: s['dot-line']
    })));
};
MainToggle.displayName = 'MainToggle';
export default MainToggle;
